import { MY_WISHLIST } from '../ids';
import { InstallLocation } from '../types';
import { formatDescription } from '../utils';
export const ids = MY_WISHLIST;
export const getDefinition = (staticsUrl, t) => ({
    ...ids,
    installLocation: InstallLocation.Standalone,
    social: false,
    showInLoginMenu: true,
    method: 'addSection',
    shouldInstallInitially: false,
    urlOverride: 'my-wishlist',
    page: {
        name: t('memberPages.addModal.memberPagesTab.wishlist.title'),
        shortDescription: t('memberPages.addModal.memberPagesTab.wishlist.body'),
        description: formatDescription({
            text: t('memberPages.addModal.memberPagesTab.wishlist.description.body'),
            bulletPoints: [
                t('memberPages.addModal.memberPagesTab.wishlist.description.bullet1'),
                t('memberPages.addModal.memberPagesTab.wishlist.description.bullet2'),
            ],
        }),
        iconURL: `${staticsUrl}assets/images/icons/stores-icon.png`,
        origin: t('memberPages.addModal.memberPagesTab.by.stores.label'),
        screenshots: [`${staticsUrl}assets/images/my-wishlist/my-wallet.png`],
    },
});
//# sourceMappingURL=my-wishlist.js.map